import React from "react";
import BukkuTooltip from ".";

/**
 *
 * @param {ReactNode} children
 * @param {Object[]} rules array of object with key 'condition' and 'message', last item in array prioritized
 *                      eg:
 *          rules={[
                    {
                        condition: looseCondition === true,
                        message: t`Online Payment for SGD is only supported by Stripe.`,
                    },
                    {
                        condition: lessStrictCondition === true,
                        message: t`Payment gateway needs to be activated.`,
                    },
                    {
                        condition: strictestCondition === true,
                        message: t`Bukku Store needs to be activated.`,
                    },
                ]}
 * @returns the children with tooltip wrapped.
            NOTE: may not work with <Form.Item/> as parent. Requires controlled component using setState
 */
export function ConditionalTooltip({children, rules, popupContainerId, ...restProps}) {
    let appliedRule;
    rules.forEach(r => {
        const {condition} = r;
        if (condition)
            appliedRule = r;
    });
    if (appliedRule) {
        const {message} = appliedRule;
        return (
            <BukkuTooltip title={message} popupContainerId={popupContainerId || null} {...restProps}>
                {
                    React.cloneElement(children)
                }
            </BukkuTooltip>
        );
    }
    return children;
}
